<div class="fondoGeneral">
   <mat-drawer-container class="drawContainer">
      <div class="header"></div>
      <empusa-microapp-fbs-facility-list></empusa-microapp-fbs-facility-list>
   </mat-drawer-container> 
</div>